// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","389":"90fc096b","732":"6c3112d7","977":"0aa2c955"}[chunkId] + ".chunk.js";
};